export default function PlanDivider() {
	return (
		<div className="flex w-full justify-center">
			<div className="h-px w-[80px] bg-[rgba(0,0,0,0.08)]" />
		</div>
	);
}
